import { node } from "~/util/dom";
import createSDSIcon from "../icon";
import { MYMAPS_VISITED_EMPTY, MYMAPS_VISITED_FILLED } from "../sds-compatible-icons";
import Tooltip, { ETooltipFlow, ETooltipPosition } from "../tooltip";

interface IState {
	checked: boolean;
}

interface IMyMapsVisited<T> {
	checked?: boolean;
	clickable?: boolean;
	tooltip?: {
		checked: string;
		unchecked: string;
	};
	onClick?: (target: T) => void;
}

export default class MyMapsVisited {
	_opts: IMyMapsVisited<MyMapsVisited>;

	_state: IState;

	_dom: {
		container: HTMLSpanElement;
		filled: HTMLMapyIconElement;
		empty: HTMLMapyIconElement;
		tooltipContent: HTMLParagraphElement;
	};

	constructor(opts: IMyMapsVisited<MyMapsVisited>) {
		this._opts = {
			checked: false,
			clickable: false,
			tooltip: null,
			onClick: () => {},
			...opts,
		};
		this._state = {
			checked: this._opts.checked,
		};

		this._build();
	}

	get container() {
		return this._dom.container;
	}

	get checked() {
		return this._state.checked;
	}

	set checked(checked: boolean) {
		this._state.checked = checked;
		this._updateUIByState();
	}

	_build() {
		const container = node("span", { className: "mymapsVisited" });
		const filledIcon = createSDSIcon({ symbol: MYMAPS_VISITED_FILLED, className: "mymapsVisited__icon" });
		const emptyIcon = createSDSIcon({ symbol: MYMAPS_VISITED_EMPTY, className: "mymapsVisited__icon" });
		const tooltipContent = node("p", { textContent: "" });

		if (this._opts.tooltip) {
			/* eslint-disable-next-line */
			new Tooltip({
				anchor: container,
				trigger: container,
				triggerEventType: "pointerenter",
				content: tooltipContent,
				arrow: false,
				flow: ETooltipFlow.CENTER,
				position: ETooltipPosition.TOP,
				offset: [2, 0, 0, 0],
			});
		}

		if (this._opts.clickable) {
			container.classList.add("clickable");
			container.addEventListener("click", () => {
				this._opts.onClick(this);
			});
		}

		this._dom = {
			container,
			filled: filledIcon,
			empty: emptyIcon,
			tooltipContent,
		};

		this._updateUIByState();
	}

	_updateUIByState() {
		if (this._state.checked) {
			this._dom.empty.remove();
			this._dom.container.append(this._dom.filled);

			if (this._opts.tooltip) {
				this._dom.tooltipContent.textContent = this._opts.tooltip.checked;
			}
		} else {
			this._dom.filled.remove();
			this._dom.container.append(this._dom.empty);

			if (this._opts.tooltip) {
				this._dom.tooltipContent.textContent = this._opts.tooltip.unchecked;
			}
		}
	}
}
